import { DMCObject } from "./DMCObject";
import { Weather } from "../EditTools/WeatherTool";

export class DMCWeather extends DMCObject {
  constructor(name, konvaObject, dataWeather) {
    super(name, konvaObject);

    this.dataWeather = dataWeather;
  }

  copyOption(DMCObject, creationController) {
    const newOption = super.copyOption(DMCObject, creationController);
    return newOption;
  }

  getType() {
    return "Weather";
  }

  async load(controllerProject, DMCObject, incorporate) {
    const weatherTool = new Weather();

    this.name = DMCObject.name;
    this.dataWeather = DMCObject.dataWeather;
    weatherTool.weather(DMCObject.dataWeather, this.name);
    DMCObject.konvaObjectOption = this.copyOption(DMCObject, controllerProject);
    this.konvaObject = await weatherTool.loadSpec(controllerProject, DMCObject, incorporate);
    this.konvaObjectOption = this.konvaObject.attrs;

    this.loadEnd(DMCObject);
    return this;
  }

  loadEnd(obj) {
    try {
      const color = obj.dataWeather.color;
      const font = obj.dataWeather.font;
      // Restore properties
      this.setColor(color);
      this.setFont(font);
    } catch (err) {
      console.error("Error reading scroll properties:", err);
    }
    return obj;
  }

  options() {
    return ["RectPartial", "Weather"];
  }

  // Setters
  setColor(val) {
    for (const child of this.konvaObject.children) {
      // Define fill attribute in each child with text
      if (child.attrs.name !== undefined) {
        // Check if group of objects
        if (child.attrs.name.includes("group")) {
          for (const secondChild of child.children) {
            // Change color of each child
            if (secondChild.attrs.name !== undefined && secondChild.attrs.text !== undefined) {
              if (secondChild.attrs.name.includes("text")) {
                secondChild.setAttr("fill", val);
              }
            }
          }
        } else if (child.attrs.text !== undefined) {
          // If not group change color directly
          if (child.attrs.name.includes("text")) {
            child.setAttr("fill", val);
          }
        }
      }
    }

    // Update color in dataWeather to save it in project
    this.dataWeather.color = val;

    return val;
  }

  setFont(val) {
    for (const child of this.konvaObject.children) {
      // Define fontFamily attribute in each child with text
      if (child.attrs.name !== undefined) {
        // Check if group of objects
        if (child.attrs.name.includes("group")) {
          for (const secondChild of child.children) {
            // Change color of each child
            if (secondChild.attrs.name !== undefined && secondChild.attrs.text !== undefined) {
              if (secondChild.attrs.name.includes("text")) {
                secondChild.setAttr("fontFamily", val);
              }
            }
          }
        } else if (child.attrs.text !== undefined) {
          // If not group change color directly
          if (child.attrs.name.includes("text")) {
            child.setAttr("fontFamily", val);
          }
        }
      }
    }

    // Update font in dataWeather to save it in project
    this.dataWeather.font = val;

    return val;
  }
}
